<app-base-page>
  @if (isInitialLoad()) {
    <app-loading-spinner />
  } @else {
    @defer (when parentForm) {
      <section [formGroup]="parentForm!" class="scheduler-wrap">
        @if (isSaving()) {
          <div class="list-loading-overlay" aria-live="polite">
            <app-loading-spinner />
          </div>
        }
      <div class="display-grid">
        <div
          class="fw-bold d-flex align-items-center color-header bg-header pl-1 shift"
        >
          {{ "front.staff-scheduler-page.shift" | translate | uppercase }}
        </div>
        @for (weekDay of weekDays; track $index) {
          <div
            class="fw-bold bg-header color-header d-flex align-items-center header-padding"
          >
            {{
              "front.staff-scheduler-page." + weekDay.label
                | translate
                | uppercase
            }}
          </div>
        }
      </div>
      <div formArrayName="shifts">
        @for (
          shift of shifts.controls;
          track shift.value;
          let shiftIndex = $index
        ) {
          <div class="display-grid" [formGroupName]="shiftIndex">
            <div
              class="d-flex align-items-start bg-header color-header pt-2 px-2 head"
            >
              <div class="d-flex gap-2 align-items-center shift-p">
                {{ "front.staff-scheduler-page.shift" | translate | uppercase }}
                {{ shift.value.shiftNumber }}
                <div class="time-p">
                  ({{ shift.value.startTime }} to {{ shift.value.endTime }})
                </div>
                <a
                  (click)="openEditShiftModal(shift.value)"
                  class="d-flex gap-2 edit-btn"
                >
                  <i
                    class="cursor-pointer bi bi-pencil-square text-primary"
                  ></i>
                </a>
              </div>
            </div>
            <div
              class="pl-1 pt-2 d-flex justify-content-between"
              [formArrayName]="weekDay.MONDAY"
            >
              <div class="w-full">
                @for (
                  assignment of getWeeDay(shiftIndex, weekDay.MONDAY).controls;
                  track assignment.value;
                  let assignmentIndex = $index
                ) {
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div [formGroupName]="assignmentIndex">
                      {{ assignment.value.name }}
                    </div>
                    <i
                      class="bi bi-x"
                      (click)="
                        removeAssignment(
                          shiftIndex,
                          weekDay.MONDAY,
                          assignmentIndex
                        )
                      "
                    ></i>
                  </div>
                } @empty {
                  <div style="color: #f1a36b">
                    {{ "front.assigment-tabel.assign" | translate }}
                  </div>
                }
              </div>
              <div class="arrow">
                <app-shift-scheduler-popover-edit
                  [parentForm]="parentForm"
                  [shiftIndex]="shiftIndex"
                  [users]="filteredTeamMembers()"
                  [weekDay]="weekDay.MONDAY"
                  (popoverChangeSelection)="handlePopoverSelection($event)"
                />
              </div>
            </div>
            <div
              class="pl-1 pt-2 d-flex justify-content-between"
              [formArrayName]="weekDay.TUESDAY"
            >
              <div class="w-full">
                @for (
                  assignment of getWeeDay(shiftIndex, weekDay.TUESDAY).controls;
                  track assignment.value;
                  let assignmentIndex = $index
                ) {
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div [formGroupName]="assignmentIndex">
                      {{ assignment.value.name }}
                    </div>
                    <i
                      class="bi bi-x"
                      (click)="
                        removeAssignment(
                          shiftIndex,
                          weekDay.TUESDAY,
                          assignmentIndex
                        )
                      "
                    ></i>
                  </div>
                } @empty {
                  <div style="color: #f1a36b">
                    {{ "front.assigment-tabel.assign" | translate }}
                  </div>
                }
              </div>
              <div class="arrow">
                <app-shift-scheduler-popover-edit
                  [parentForm]="parentForm"
                  [shiftIndex]="shiftIndex"
                  [users]="filteredTeamMembers()"
                  [weekDay]="weekDay.TUESDAY"
                  (popoverChangeSelection)="handlePopoverSelection($event)"
                />
              </div>
            </div>
            <div
              class="pl-1 pt-2 d-flex justify-content-between"
              [formArrayName]="weekDay.WEDNESDAY"
            >
              <div class="w-full">
                @for (
                  assignment of getWeeDay(shiftIndex, weekDay.WEDNESDAY)
                    .controls;
                  track assignment.value;
                  let assignmentIndex = $index
                ) {
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div [formGroupName]="assignmentIndex">
                      {{ assignment.value.name }}
                    </div>
                    <i
                      class="bi bi-x"
                      (click)="
                        removeAssignment(
                          shiftIndex,
                          weekDay.WEDNESDAY,
                          assignmentIndex
                        )
                      "
                    ></i>
                  </div>
                } @empty {
                  <div style="color: #f1a36b">
                    {{ "front.assigment-tabel.assign" | translate }}
                  </div>
                }
              </div>
              <div class="arrow">
                <app-shift-scheduler-popover-edit
                  [parentForm]="parentForm"
                  [shiftIndex]="shiftIndex"
                  [users]="filteredTeamMembers()"
                  [weekDay]="weekDay.WEDNESDAY"
                  (popoverChangeSelection)="handlePopoverSelection($event)"
                />
              </div>
            </div>
            <div
              class="pl-1 pt-2 d-flex justify-content-between"
              [formArrayName]="weekDay.THURSDAY"
            >
              <div class="w-full">
                @for (
                  assignment of getWeeDay(shiftIndex, weekDay.THURSDAY)
                    .controls;
                  track assignment.value;
                  let assignmentIndex = $index
                ) {
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div [formGroupName]="assignmentIndex">
                      {{ assignment.value.name }}
                    </div>
                    <i
                      class="bi bi-x"
                      (click)="
                        removeAssignment(
                          shiftIndex,
                          weekDay.THURSDAY,
                          assignmentIndex
                        )
                      "
                    ></i>
                  </div>
                } @empty {
                  <div style="color: #f1a36b">
                    {{ "front.assigment-tabel.assign" | translate }}
                  </div>
                }
              </div>
              <div class="arrow">
                <app-shift-scheduler-popover-edit
                  [parentForm]="parentForm"
                  [shiftIndex]="shiftIndex"
                  [users]="filteredTeamMembers()"
                  [weekDay]="weekDay.THURSDAY"
                  (popoverChangeSelection)="handlePopoverSelection($event)"
                />
              </div>
            </div>
            <div
              class="pl-1 pt-2 d-flex justify-content-between"
              [formArrayName]="weekDay.FRIDAY"
            >
              <div class="w-full">
                @for (
                  assignment of getWeeDay(shiftIndex, weekDay.FRIDAY).controls;
                  track assignment.value;
                  let assignmentIndex = $index
                ) {
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div [formGroupName]="assignmentIndex">
                      {{ assignment.value.name }}
                    </div>
                    <i
                      class="bi bi-x"
                      (click)="
                        removeAssignment(
                          shiftIndex,
                          weekDay.FRIDAY,
                          assignmentIndex
                        )
                      "
                    ></i>
                  </div>
                } @empty {
                  <div style="color: #f1a36b">
                    {{ "front.assigment-tabel.assign" | translate }}
                  </div>
                }
              </div>
              <div class="arrow">
                <app-shift-scheduler-popover-edit
                  [parentForm]="parentForm"
                  [shiftIndex]="shiftIndex"
                  [users]="filteredTeamMembers()"
                  [weekDay]="weekDay.FRIDAY"
                  (popoverChangeSelection)="handlePopoverSelection($event)"
                />
              </div>
            </div>
            <div
              class="pl-1 pt-2 d-flex justify-content-between"
              [formArrayName]="weekDay.SATURDAY"
            >
              <div class="w-full">
                @for (
                  assignment of getWeeDay(shiftIndex, weekDay.SATURDAY)
                    .controls;
                  track assignment.value;
                  let assignmentIndex = $index
                ) {
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div [formGroupName]="assignmentIndex">
                      {{ assignment.value.name }}
                    </div>
                    <i
                      class="bi bi-x"
                      (click)="
                        removeAssignment(
                          shiftIndex,
                          weekDay.SATURDAY,
                          assignmentIndex
                        )
                      "
                    ></i>
                  </div>
                } @empty {
                  <div style="color: #f1a36b">
                    {{ "front.assigment-tabel.assign" | translate }}
                  </div>
                }
              </div>
              <div class="arrow">
                <app-shift-scheduler-popover-edit
                  [parentForm]="parentForm"
                  [shiftIndex]="shiftIndex"
                  [users]="filteredTeamMembers()"
                  [weekDay]="weekDay.SATURDAY"
                  (popoverChangeSelection)="handlePopoverSelection($event)"
                />
              </div>
            </div>
            <div
              class="pl-1 pt-2 d-flex justify-content-between"
              [formArrayName]="weekDay.SUNDAY"
            >
              <div class="w-full">
                @for (
                  assignment of getWeeDay(shiftIndex, weekDay.SUNDAY).controls;
                  track assignment.value;
                  let assignmentIndex = $index
                ) {
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div [formGroupName]="assignmentIndex">
                      {{ assignment.value.name }}
                    </div>
                    <i
                      class="bi bi-x"
                      (click)="
                        removeAssignment(
                          shiftIndex,
                          weekDay.SUNDAY,
                          assignmentIndex
                        )
                      "
                    ></i>
                  </div>
                } @empty {
                  <div style="color: #f1a36b">
                    {{ "front.assigment-tabel.assign" | translate }}
                  </div>
                }
              </div>
              <div class="arrow">
                <app-shift-scheduler-popover-edit
                  [parentForm]="parentForm"
                  [shiftIndex]="shiftIndex"
                  [users]="filteredTeamMembers()"
                  [weekDay]="weekDay.SUNDAY"
                  (popoverChangeSelection)="handlePopoverSelection($event)"
                />
              </div>
            </div>
          </div>
        }
      </div>
      <section class="d-flex justify-content-end mt-4">
        <div class="d-flex gap-3">
          <cancel-btn
            (click)="resetForm()"
            [disabled]="parentForm!.disabled"
          ></cancel-btn>
          <save-btn
            [label]="'front.save-btn.save-changes'"
            (click)="saveChanges()"
            [disabled]="parentForm!.disabled"
          ></save-btn>
        </div>
      </section>
    </section>
    } @loading (minimum 1500) {
      <app-loading-spinner />
    }
  }
</app-base-page>
